export const HASH_ELEMENT_IDS = {
	groupSize: 'group-size',
	calendar: 'calendar',
	timeslots: 'timeslots'
};